import { LectioJSUtils } from "../LectioJSUtils";

export namespace LectioEditorLinkPlugin {

	export function GetSelectedLink(editor: CKEDITOR.editor) {
		let existingLink: CKEDITOR.dom.element | null;
		//const selection = editor.getSelection();

		// Fill in all the relevant fields if there's already one link selected.
		if ((existingLink = CKEDITOR.plugins.link.getSelectedLink(editor) as any) && (existingLink as any).hasAttribute('href')) {
			// Don't change selection if some element is already selected.
			// For example - don't destroy fake selection.
			//if (!selection.getSelectedElement())
			//	selection.selectElement(existingLink);
		} else {
			existingLink = null;
		}
		return existingLink;
	}

	export function GetAdjustedHref(hrefInitial: string): string {
		let hrefAdjusted = hrefInitial;
		// Tilføj (bud på) protokol, hvis brugeren ikke har angivet en.
		const hasProtocolPrefix = !!hrefInitial.match(/^[a-z]+:/i);
		const looksLikePath = !!hrefInitial.match(/^~?\//);
		if (!hasProtocolPrefix && !looksLikePath) {
			if (hrefInitial.match(/@/) && !hrefInitial.match(/:.*@/i))
				hrefAdjusted = 'mailto:' + hrefInitial;
			else
				hrefAdjusted = 'http://' + hrefInitial;
		}
		return hrefAdjusted;
	}

	export function InsertLink(
		editor: CKEDITOR.editor,
		hrefInitial: string,
		hrefAdjusted: string,
		text: string
	): void {
		const selection = editor.getSelection()!;
		const range = selection.getRanges()[0];

		const wasCollapsed = range.collapsed;
		let textNode: CKEDITOR.dom.text | null = null;

		// Use link URL as text with a collapsed cursor.
		if (wasCollapsed) {
			textNode = new CKEDITOR.dom.text(text || hrefInitial, editor.document);
			range.insertNode(textNode);
			range.selectNodeContents(textNode);
		}

		// Apply style.
		const style = new CKEDITOR.style({
			element: 'a',
			attributes: {
				href: hrefAdjusted,
				'data-lc-display-linktype': 'external',
			}
		});

		style.type = CKEDITOR.STYLE_INLINE; // need to override... dunno why.
		style.applyToRange(range, editor);

		if (wasCollapsed && textNode)
			range.moveToElementEditEnd(textNode);	// Move to the end of the newly created link, if text was not previously selected.

		range.select();

		LectioJSUtils.DispatchBrowserTestEvent('lectiolink_linkinserted');
	}
}
